$('.js-section').each(function() {
  var $this          = $(this),
      elementWatcher = scrollMonitor.create($this, -100);
  elementWatcher.enterViewport(function() {
    $this.addClass('section-active');
  });
  elementWatcher.exitViewport(function() {
    $this.removeClass('section-active');
});
});
$('.js-autoplay').each(function() {
  var $this          = $(this),
  vidWatcher = scrollMonitor.create($this);
  vidWatcher.enterViewport(function() {
    $this[0].play();
  });
  vidWatcher.exitViewport(function() {
    $this[0].pause();
});
});
